"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryRulesCalculator = void 0;
const lodash_1 = __importDefault(require("lodash"));
const moment_1 = __importDefault(require("moment"));
const deliveryRulesConstants_1 = require("./deliveryRulesConstants");
const DeliveryRulesBase_1 = require("./DeliveryRulesBase");
const deliveryRulesConstants_2 = require("./deliveryRulesConstants");
function matchBasedOnZipCodeRange(zipCode, rule) {
    if (!rule.applicableWhen?.validZipCodes) {
        return false;
    }
    return rule.applicableWhen.validZipCodes.some(zipCodePattern => {
        const splitOnDash = zipCodePattern.split('-');
        if (splitOnDash && splitOnDash.length === 2) {
            const start = parseInt(splitOnDash[0].replaceAll('x', '0'), 10);
            const end = parseInt(splitOnDash[1].replaceAll('x', '9'), 10);
            return start <= parseInt(zipCode, 10) && end >= parseInt(zipCode, 10);
        }
        return false;
    });
}
function matchBasedOnZipCodePattern(zipCode, rule) {
    if (!rule.applicableWhen?.validZipCodes) {
        return false;
    }
    return rule.applicableWhen.validZipCodes.some(zipCodePattern => {
        const patternString = zipCodePattern.replaceAll('x', '.');
        const zipCodeRegex = new RegExp(patternString);
        return zipCodeRegex.test(zipCode);
    });
}
class DeliveryRulesCalculator extends DeliveryRulesBase_1.DeliveryRulesBase {
    applicableRules(rules, customerSelectedDeliveryRules) {
        if (rules == null || !Array.isArray(rules)) {
            return [];
        }
        const rulesSelectedByCustomer = rules.filter(rule => {
            if (!customerSelectedDeliveryRules) {
                return true;
            }
            if (!rule.delivery?.weekday) {
                return true;
            }
            return customerSelectedDeliveryRules[rule.delivery.weekday];
        });
        const zipCodeRelatedRules = rulesSelectedByCustomer.filter(rule => {
            if (!this.zipCode || !rule.applicableWhen?.validZipCodes) {
                return false;
            }
            return (matchBasedOnZipCodeRange(this.zipCode, rule) ||
                matchBasedOnZipCodePattern(this.zipCode, rule));
        });
        if (zipCodeRelatedRules.length > 0) {
            return zipCodeRelatedRules;
        }
        return rulesSelectedByCustomer.filter(rule => {
            if (rule.applicableWhen?.validZipCodes?.includes(deliveryRulesConstants_1.DeliveryRulesGeneralRegion)) {
                return true;
            }
            if (!rule.applicableWhen?.validZipCodes) {
                return true;
            }
            return false; // Ensure all code paths return a value
        });
    }
    getDeliveryRulesByPriority() {
        let selectedDeliveryRules = null;
        if (this.supplierConnection?.deliveryRules) {
            selectedDeliveryRules = {};
            this.supplierConnection.deliveryRules.map(rule => {
                if (rule.selectedRoute?.weekday) {
                    selectedDeliveryRules[rule.selectedRoute.weekday] = true;
                }
            });
        }
        else if (this.customerSubUnit?.deliveryRules) {
            selectedDeliveryRules = {};
            this.customerSubUnit.deliveryRules.map(rule => {
                if (rule.selectedRoute?.weekday) {
                    selectedDeliveryRules[rule.selectedRoute.weekday] = true;
                }
            });
        }
        if (this.supplierCustomer?.deliveryRules) {
            return this.applicableRules(this.supplierCustomer.deliveryRules, selectedDeliveryRules);
        }
        if (this.orderFullfillmentCenter?.deliveryRules) {
            return this.applicableRules(this.orderFullfillmentCenter.deliveryRules, selectedDeliveryRules);
        }
        return [];
    }
    constructor(orderFullfillmentCenter, customerSubUnit, supplierCustomer, supplierConnection) {
        super(null);
        this.orderFullfillmentCenter = orderFullfillmentCenter;
        this.supplierCustomer = supplierCustomer;
        this.customerSubUnit = customerSubUnit;
        this.supplierConnection = supplierConnection;
        if (this.supplierCustomer?.deliveryZipCode) {
            this.zipCode = this.supplierCustomer?.deliveryZipCode;
        }
        else {
            this.zipCode =
                this.customerSubUnit?.deliveryZipCode ||
                    this.customerSubUnit?.invoiceZipCode;
        }
        if (this.zipCode) {
            this.zipCode = this.zipCode.replace(' ', '');
            this.zipCode = this.zipCode.replace('-', '');
        }
        let deliveryRules = this.getDeliveryRulesByPriority();
        if (this.orderFullfillmentCenter?.deliveryRuleOverrides) {
            deliveryRules = [
                ...deliveryRules,
                ...this.applicableRules(this.orderFullfillmentCenter?.deliveryRuleOverrides, null),
            ];
        }
        this.initializeRules(deliveryRules);
    }
    isPossibleToGetDeliveryOnDate(date, now) {
        if (now == null) {
            now = new Date(Date.now());
        }
        const day = deliveryRulesConstants_2.weekdaysMapping[(0, moment_1.default)(date).weekday()];
        if (this.deliveryRulesByKey[day]) {
            const dayDate = (0, moment_1.default)(date).format('YYYY-MM-DD');
            let rules = [];
            if (this.deliveryRulesByKey[dayDate]) {
                rules = this.deliveryRulesByKey[dayDate];
            }
            else {
                rules = this.deliveryRulesByKey[day];
            }
            if (rules.length > 0) {
                for (const deliveryRule of rules) {
                    let breakTimeForRule = deliveryRule.getBreakTimeForDate(date);
                    if (lodash_1.default.isNil(breakTimeForRule)) {
                        continue;
                    }
                    // console.log('!!!calendar date', date);
                    // console.log(
                    //   'now',
                    //   now,
                    //   'calendar date',
                    //   date,
                    //   'breakTimeForRule',
                    //   breakTimeForRule,
                    // );
                    const nrOfDaysBlockedBetweenDateAndBreakTime = this.blockedPickAndPackDatesManager.getNrOfBlockedPickAndPackDatesManagerBetween(breakTimeForRule, date);
                    // console.log(
                    //   'nrOfDaysBlockedBetweenDateAndBreakTime',
                    //   nrOfDaysBlockedBetweenDateAndBreakTime,
                    // );
                    breakTimeForRule = (0, moment_1.default)(breakTimeForRule)
                        .subtract(nrOfDaysBlockedBetweenDateAndBreakTime, 'days')
                        .toDate();
                    // console.log(
                    //   'now',
                    //   now,
                    //   'calendar date',
                    //   date,
                    //   'breakTimeForRule',
                    //   breakTimeForRule,
                    //   'nrOfDaysBlockedBetweenDateAndBreakTime',
                    //   nrOfDaysBlockedBetweenDateAndBreakTime,
                    //   'expression',
                    //   moment(breakTimeForRule)
                    //     .subtract(nrOfDaysBlockedBetweenDateAndBreakTime, 'days')
                    //     .isAfter(now), // future
                    // );
                    if ((0, moment_1.default)(breakTimeForRule).isAfter(now) // future
                    ) {
                        return true;
                    }
                }
            }
        }
        return false;
    }
    getDeliverableDays(fromDateTime, untilDateTime) {
        const result = {};
        const from = (0, moment_1.default)(fromDateTime ?? new Date(Date.now())); // här kommer det bli knas med tidszoner date.now() kommer ge olika svar på server och klienten
        const to = (0, moment_1.default)(untilDateTime ?? from.clone().add(43, 'days'));
        for (let m = from.clone(); m.isBefore(to); m.add(1, 'days')) {
            if (this.isPossibleToGetDeliveryOnDate(m.toDate(), from.toDate())) {
                result[m.format('YYYY-MM-DD')] = true;
            }
        }
        return Object.keys(result);
    }
    getEarliestPossibleDeliveryDate(numberOfExtraDeliveryDays, now = moment_1.default.now()) {
        const earliestDeliveryDateArticle = (0, moment_1.default)(now)
            .add(numberOfExtraDeliveryDays, 'days')
            .toDate();
        const possibleDeliveryDays = this.getDeliverableDays(earliestDeliveryDateArticle);
        return lodash_1.default.first(possibleDeliveryDays);
    }
    checkIfCanDeliverOnOrBeforeDate(requestedDeliveryDate, numberOfExtraDeliveryDays) {
        if (!numberOfExtraDeliveryDays || numberOfExtraDeliveryDays === 0)
            return true;
        if (!requestedDeliveryDate && numberOfExtraDeliveryDays > 0) {
            return false;
        }
        const firstPossibleDeliveryDate = this.getEarliestPossibleDeliveryDate(numberOfExtraDeliveryDays);
        const requestedDate = (0, moment_1.default)(requestedDeliveryDate);
        if ((0, moment_1.default)(firstPossibleDeliveryDate).isAfter(requestedDate, 'day')) {
            return false;
        }
        return true;
    }
}
exports.DeliveryRulesCalculator = DeliveryRulesCalculator;
